// <overlay-component id="example-overlay">
// <div class="overlay-container">
// <div class="overlay-panel" data-animation-direction="center">
// <p>This is an overlay panel!</p>
// <span class="overlay-close">Close</span>
// </div>
//</div>
// </overlay-component>;

//   <button class="overlay-trigger" data-target="example-overlay">
//     Open Overlay
//   </button>;

class InnerOverlayComponent extends HTMLElement {
  constructor() {
    super();
    this.overlay =
      document.querySelector(`[data-overlay-container="${this.id}"]`) || this.querySelector('.overlay-container');
    this.parentOverlay = this.closest('[data-overlay-container]') || this.closest('.overlay-container');

    this.closeButtons = this.querySelectorAll('.overlay-inner-close');

    this.buttonsOutsideContext = this.getAttribute('buttons-outside-context') || 'false';
    if (this.buttonsOutsideContext == 'true') {
      this.triggerButtons = document.querySelectorAll(`.overlay-trigger[data-target="${this.id}"]`);
    } else {
      this.triggerButtons = this.querySelectorAll(`.overlay-trigger[data-target="${this.id}"]`);
    }
    if (!this.overlay) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.overlay.addEventListener('click', this.onOverlayClick.bind(this));
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.closeOverlay.bind(this));
    });
    this.triggerButtons.forEach((button) => {
      button.addEventListener('click', this.openOverlay.bind(this));
    });
    window.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onKeyUp(event) {
    if (event.key === 'Escape') {
      this.closeOverlay();
    }
  }

  onOverlayClick(event) {
    if (event.target === this.overlay) {
      this.closeOverlay();
    }
  }

  openOverlay() {
    if (this.overlay.classList.contains('is-open')) return;
    this.overlay.classList.add('is-open');

    // Add class to parent overlay
    this.parentOverlay?.classList?.add('has-inner-overlay-open');

    document.body.style.overflow = 'hidden';
    this.animateSlideIn();
    this.dispatchEvent(new CustomEvent('overlay-component:open'));
  }

  closeOverlay() {
    this.animateSlideOut().then(() => {
      this.overlay.classList.remove('is-open');

      // Add class to parent overlay
      this.parentOverlay?.classList?.remove('has-inner-overlay-open');

      this.dispatchEvent(new CustomEvent('overlay-component:close'));
    });
  }

  animateSlideIn() {
    const panel = this.overlay.querySelector('.overlay-panel');
    const direction = panel.dataset.animationDirection;
    const easing = getComputedStyle(document.documentElement).getPropertyValue('--ease-smooth').trim() || 'ease';

    if (direction === 'left' || direction === 'right') {
      const offset = direction === 'left' ? -100 : 100;
      panel.animate([{ transform: `translateX(${offset}%)` }, { transform: 'translateX(0)' }], {
        duration: 700,
        easing: easing,
        fill: 'forwards',
      });
    } else if (direction === 'center') {
      panel.style.opacity = 0;
      panel.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 1000,
        easing: easing,
        fill: 'forwards',
      });
    }
  }

  animateSlideOut() {
    return new Promise((resolve) => {
      const panel = this.overlay.querySelector('.overlay-panel');
      const direction = panel.dataset.animationDirection;
      const easing = getComputedStyle(document.documentElement).getPropertyValue('--ease-smooth').trim() || 'ease';

      if (direction === 'left' || direction === 'right') {
        const offset = direction === 'left' ? -100 : 100;
        const animation = panel.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${offset}%)` }], {
          duration: 300,
          easing: easing,
          fill: 'forwards',
        });
        animation.onfinish = resolve;
      } else if (direction === 'center') {
        const animation = panel.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 300,
          easing: easing,
          fill: 'forwards',
        });
        animation.onfinish = resolve;
      }
    });
  }
}

customElements.define('inner-overlay-component', InnerOverlayComponent);
